export const ACCESS_CODE = '100318';
export const ACCESS_STORAGE_KEY = 'passswords_authenticated';

export const isAccessGranted = () =>
  localStorage.getItem(ACCESS_STORAGE_KEY) === 'true';

export const grantAccess = () => {
  localStorage.setItem(ACCESS_STORAGE_KEY, 'true');
};

export const formatAccessDigits = (digits) => {
  if (!digits) return '';
  return digits.split('').join(' - ');
};

export const parseAccessInput = (value) =>
  value.replace(/\D/g, '').slice(0, 6);
